export const workdeskTicketsConstants = {
  LOAD_TICKETS_REQUEST: 'WORKDESK_LOAD_TICKETS_REQUEST',
  LOAD_TICKETS_SUCCESS: 'WORKDESK_LOAD_TICKETS_SUCCESS',
  WS_LOAD_TICKETS_SUCCESS: 'WS_LOAD_TICKETS_SUCCESS',
  LOAD_TICKETS_ERROR: 'WORKDESK_LOAD_TICKETS_ERROR',
  CLEAR_JUST_CHANGE_TICKET_ID: 'WORKDESK_CLEAR_JUST_CHANGE_TICKET_ID',
  UPDATE_TICKET: 'WORKDESK_UPDATE_TICKET',

  LOAD_BODY_HTMLS_REQUEST: 'LOAD_BODY_HTMLS_REQUEST',
  LOAD_BODY_HTMLS_REQUEST_SUCCESS: 'LOAD_BODY_HTMLS_REQUEST_SUCCESS',
  LOAD_BODY_HTMLS_REQUEST_ERROR: 'LOAD_BODY_HTMLS_REQUEST_ERROR',

  PREVIEW_BODY_HTML_ID: 'PREVIEW_BODY_HTML_ID',
  CLOSE_PREVIEW_BODY_HTML_ID: 'CLOSE_PREVIEW_BODY_HTML_ID',

  WS_LOAD_TICKETS_REQUEST: 'WS_LOAD_TICKETS_REQUEST',

  UPDATE_TICKETS: 'UPDATE_TICKETS',

  REMOVE_TICKETS_IN_HASLOADED_AT_PARAMS:
    'REMOVE_TICKETS_IN_HASLOADED_AT_PARAMS',

  ADD_STATUS_CHANGED_IDS: 'ADD_STATUS_CHANGED_IDS',
  REMOVE_STATUS_CHANGED_IDS: 'REMOVE_STATUS_CHANGED_IDS',

  MERGE_TICKETS_TO_TICKETS_MAP: 'MERGE_TICKETS_TO_TICKETS_MAP',

  UPDATE_ALL_INBOXES_STATUS_LATEST_UPDATE_DATE:
    'UPDATE_ALL_INBOXES_STATUS_LATEST_UPDATE_DATE',

  MARK_IS_JUST_CHANGED: 'MARK_IS_JUST_CHANGED',
  REMOVE_IDS_FROM_WS_TICKET_IDS: 'REMOVE_IDS_FROM_WS_TICKET_IDS',

  RESET: 'WORKDESK_TICKETS_RESET',
};

export const WS_REQ_UPDATE_EVENT = 'request ticket update';
export const WS_GET_UPDATE_EVENT = 'get ticket update';

export const WS_ERROR = 'error handling';
